import styled from '@emotion/styled';
import { Icon } from '@pairy/pds-react';

export const LinkIcon = styled(Icon)`
  transform: rotate(90deg);
`;
